import React, { useMemo } from "react";
import { SFResponsive, SFLoadingScreen } from "@sf-core";
import SigninContainer from "./screens/signin";
import SigninForm from "./screens/signin/signinForm";
import TenantForm from "./screens/signin/tenantForm";
//import LoadingScreen from "./screens/signin/loading";
import UnAuthorizedScreen from "./screens/signin/unAuthorized";
import Maintenance from "./screens/maintenance";
import { BaseApp } from "@base-provider";
import { useTranslation } from "react-i18next";
import RoutesWrapper from "./screens/routesWrapper";
import PreviewWrapper from "./screens/previews/previewWrapper";
import Cookies from "./screens/policies/cookies";
import TermsPolicies from "./screens/policies/termsPolicies";
import { useSelector } from "react-redux";
import FatalError from "./screens/fatalError";

const App = ({ preview = false, routes }) => {
  const { t } = useTranslation();

  const lxpEnabledLearnerJobAndSkillVerification = useSelector(
    (state) =>
      state?.session?.tenantSettings?.lxpEnabledLearnerJobAndSkillVerification
  );

  // Filter out the routes based on the tenant setting
  const filteredRoutes = useMemo(() => {
    if (lxpEnabledLearnerJobAndSkillVerification) {
      return routes;
    } else {
      return routes.filter(
        (route) =>
          !route.path.startsWith("/profile") &&
          !route.path.startsWith("/my-progress")
      );
    }
  }, [lxpEnabledLearnerJobAndSkillVerification]);

  const screens = useMemo(() => {
    return {
      loading: () => <SFLoadingScreen />,
      maintenance: Maintenance,
      unAuthorized: () => (
        <SigninContainer>
          <UnAuthorizedScreen />
        </SigninContainer>
      ),
      login: ({ onClick }) => (
        <SigninContainer>
          <SigninForm onClick={onClick} />
        </SigninContainer>
      ),
      tenantSelect: ({ onSelect }) => (
        <SigninContainer>
          <TenantForm onSelect={onSelect} />
        </SigninContainer>
      ),
      routesWrapper: ({ children }) =>
        preview ? (
          <PreviewWrapper routes={routes}>{children}</PreviewWrapper>
        ) : (
          <RoutesWrapper routes={routes}>{children}</RoutesWrapper>
        ),
      fatalError: FatalError,
      cookies: ({ children, acceptCookies }) => (
        <Cookies acceptCookies={acceptCookies}>{children}</Cookies>
      ),
      termsPolicies: ({
        declinePolicies,
        acceptTermsConditions,
        acceptPrivacyPolicy,
        termsConditions,
        privacyPolicy,
        showAccessDenied,
      }) => (
        <TermsPolicies
          declinePolicies={declinePolicies}
          acceptTermsConditions={acceptTermsConditions}
          acceptPrivacyPolicy={acceptPrivacyPolicy}
          termsConditions={termsConditions}
          privacyPolicy={privacyPolicy}
          showAccessDenied={showAccessDenied}
        />
      ),
    };
  }, []);

  return (
    <>
      <BaseApp
        routes={filteredRoutes}
        screens={screens}
        documentTitle={t("generic.documentTitle")}
      />
      <SFResponsive />
    </>
  );
};

export default App;
